import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BroadcastMessageComponent } from './components/broadcast-message/broadcast-message.component';
import { CommsRootComponent } from './components/comms-root/comms-root.component';
import { InquiryDetailComponent } from './components/inquiry/inquiry-detail.component';
import { UserFeedbackComponent } from './components/user-feedback/user-feedback.component';

export const COMMS_ROUTES: Routes = [
	{
		path: 'broadcast-message/:id',
		component: CommsRootComponent,
	},
	{
		path: 'inquiries',
		component: InquiryDetailComponent,
	},
	{
		path: 'feedbacks',
		component: UserFeedbackComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(COMMS_ROUTES)],
	exports: [RouterModule],
})
export class CommsRoutingModule {}
